/**
 * Created by neo on 12.04.22.
 */
import { makeAutoObservable, onBecomeObserved, runInAction } from 'mobx';
import { v4 as UUID } from 'uuid';
import { MindfulnessProgramTemplateDayUnit, createMindfulnessProgramTemplateDayUnit } from './MindfulnessProgramTemplateDayUnit';
import { Media, createMedia } from '../../../Media/Media';
import { Instructor, createInstructor } from '../../../Explore/Instructor';
import { ConditionalMedia, createConditionalMedia } from '../../SuperMacro/ConditionalMedia';
import { ActivityApi } from '../../../Activity/Activity';

export type MindfulnessProgramTemplateDayUnitAudio = MindfulnessProgramTemplateDayUnit & {
  instructor: Instructor;
  backgroundImages: ConditionalMedia[];
  audios: Media[];
  spotifyPlaylistLink?: string;
  getAudio(lang: string): Media | undefined;
};

export function createMindfulnessProgramTemplateDayUnitAudio(json?: Partial<MindfulnessProgramTemplateDayUnitAudio>): MindfulnessProgramTemplateDayUnitAudio {
  const base = createMindfulnessProgramTemplateDayUnit({ ...json, type: 'audio' } as any);
  const unit: MindfulnessProgramTemplateDayUnitAudio = makeAutoObservable({
    ...base,
    instructor: createInstructor(json?.instructor as any),
    backgroundImages: (json?.backgroundImages ?? []).map((m: any) => createConditionalMedia(m)),
    audios: (json?.audios ?? []).map((a: any) => createMedia(a)),
    spotifyPlaylistLink: json?.spotifyPlaylistLink,

    getAudio(lang: string): Media | undefined {
      const languageVideo = this.audios.find((a) => a.language?.toLowerCase() === lang.toLowerCase());
      const germanVideo = this.audios.find((a) => a.language?.toLowerCase() === 'de');
      return languageVideo ?? germanVideo ?? this.audios[0];
    },

    toJS(newId: boolean = false) {
      return {
        ...(function() { const { id, createdAt, updatedAt, createdBy, updatedBy, name, description } = base; return { id: newId ? UUID() : id, createdAt, updatedAt, createdBy, updatedBy, name, description }; })(),
        instructor: this.instructor,
        audios: this.audios.map((a) => a),
        backgroundImages: this.backgroundImages.map((m) => m),
        activityIdentifier: this.activityIdentifier,
        spotifyPlaylistLink: this.spotifyPlaylistLink,
      };
    },
  });

  onBecomeObserved(unit, 'activity', () => {
    if (!unit.activity) {
      ActivityApi.get(unit.activityIdentifier).then((result) => runInAction(() => (unit.activity = result)));
    }
  });

  return unit;
}
